import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AttenderMessagingComponent } from './attender-messaging/attender-messaging.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AttenderMessagingComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatRoutingModule { }
